import { featureFlag } from '@@/auto/constants/featureFlags';
import { useConfig } from '@@/common/services/useConfig';
import { useFeatureFlags } from '@@/common/services/useFeatureFlags';

import BetterPrivacyPolicyView from './BetterPrivacyPolicyView/BetterPrivacyPolicyView';
import PrivacyPolicyView, { TPrivacyPolicyView } from './PrivacyPolicyView';
import DeprecatedPrivacyPolicyView from './PrivacyPolicyViewDeprecated';

export default function PrivacyPolicyViewWrapper(
  props: Omit<TPrivacyPolicyView, 'privacyPolicySlug'>
) {
  const { isFeatureEnabled } = useFeatureFlags();
  const {
    config: { cmsSlugs, supportEmail, privacyPolicyView, partnerCode },
  } = useConfig();

  if (partnerCode === 'toggle_better') {
    return <BetterPrivacyPolicyView cmsSlug={cmsSlugs.privacyPolicySlug} />;
  }

  if (!isFeatureEnabled(featureFlag.IS_PRIVACY_POLICY_V2_ENABLED)) {
    return (
      <DeprecatedPrivacyPolicyView
        {...props}
        privacyPolicySlug={cmsSlugs.privacyPolicySlug}
        supportEmail={supportEmail}
        {...privacyPolicyView}
      />
    );
  }

  return (
    <PrivacyPolicyView
      {...props}
      privacyPolicySlug={cmsSlugs.privacyPolicySlug}
      supportEmail={supportEmail}
      {...privacyPolicyView}
    />
  );
}
export * from './PrivacyPolicyView';
